var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCloseError = function SvgIconCloseError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.929 7.497l5.2-5.2c.1441184-.14008493.2254311-.33251768.2254311-.5335S13.2731184 1.37008493 13.129 1.23c-.291119-.29771495-.76817-.3039743-1.067-.014l-5.2 5.2-5.2-5.2c-.29850991-.2985099-.78249009-.2985099-1.081 1e-8-.2985099.2985099-.2985099.78249008 0 1.08099999l5.2 5.2-5.2 5.2c-.14411837.1400849-.22543106.3325177-.22543106.5335 0 .2009823.0813127.3934151.22543106.5335.1362375.1508081.33078465.2356948.534.2330623.20019523.0016535.39265627-.0772772.534-.2190623l5.2-5.2 5.2 5.2c.2975877.2763362.7604523.2677695 1.0476109-.0193891.2871586-.2871586.2957253-.7500232.0193891-1.0476109L7.929 7.497z",
    fill: "#EA3158",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCloseError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_close_error.459e6ef9.svg";
export { ForwardRef as ReactComponent };